import React from 'react';
import ErrorBoundaryWithLogger from 'components/common/ErrorBoundary/ErrorBoundary';
import MyStore from '../../MyStore/MyStore';
import SameDayDelivery from '../../SameDayDelivery/SameDayDelivery';
import './StoreLocatorSDD.scss';

interface Props {
  viewPortBreakpoint: string;
  setShowProgressiveTaxoDrawer: () => void;
}

const StoreLocatorAndSDD = ({ viewPortBreakpoint, setShowProgressiveTaxoDrawer }: Props) => {
  return (
    <div className="hmf-px-lg-m">
      <div className="hmf-display-flex hmf-align-items-center hmf-justify-content-between hmf-px-s">
        <ErrorBoundaryWithLogger componentId="StoreLocatorAndSDD-MyStore">
          <MyStore
            viewPortBreakpoint={viewPortBreakpoint}
            showInProgressiveTaxo
            setShowProgressiveTaxoDrawer={setShowProgressiveTaxoDrawer}
          />
        </ErrorBoundaryWithLogger>
        <ErrorBoundaryWithLogger componentId="StoreLocatorAndSDD-SameDayDelivery">
          <SameDayDelivery
            viewPortBreakpoint={viewPortBreakpoint}
            showInProgressiveTaxo
            setShowProgressiveTaxoDrawer={setShowProgressiveTaxoDrawer}
          />
        </ErrorBoundaryWithLogger>
      </div>
    </div>
  );
};

export default StoreLocatorAndSDD;
